import {Component, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {setOptions} from '@mobiscroll/angular';
import {AlertController, IonRouterOutlet} from '@ionic/angular';
import {firstValueFrom} from "rxjs";
import {filter, first, switchMap} from "rxjs/operators";
import {AuthService, NavService, StorageService, KioskService} from './services';

setOptions({
  theme: 'ios',
  themeVariant: 'light',
});

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  @ViewChild(IonRouterOutlet) routerOutlet: IonRouterOutlet;

  constructor(
    private readonly http: HttpClient,
    private readonly alert: AlertController,
    private readonly auth: AuthService,
    private readonly kiosk: KioskService,
    private readonly storage: StorageService,
    // injected only so it is constructed before the first navigation (see NavService)
    private readonly navService: NavService,
  ) {
    // check the user pin and prompt if not set
    this.kiosk.isKioskMode$.pipe(
      filter(isKioskMode => isKioskMode),
      switchMap(() => this.auth.isActive$.pipe(
        filter(isActive => isActive),
      )),
      first(),
    ).subscribe(async () => {
      const response = await firstValueFrom(
        this.http.get<{ pinSet: boolean }>('/api/auth/kiosk/check-pin', {
          withCredentials: true,
          observe: 'response',
          responseType: 'json',
        }),
      );

      if (response.ok) {
        if (!response.body.pinSet) {
          await this.setUserPin(true);
        }
      } else {
        console.log('error check user pin response: ', response);
      }
    });
  }

  get isAppMode(): boolean {
    return this.storage.isAppMode$.value;
  }

  // for the template and the function below
  get isSignedIn(): boolean {
    return this.auth.isSignedIn$.value;
  }

  async setUserPin(init: boolean = false): Promise<void> {
    const message = `Enter your PIN (4 to 6 digits) to sign in on this device.${init ? '<br/><br/><b>Notice: You can set/reset your PIN from the app menu as well.</b>' : ''}`;
    return this.kiosk.setPin(message);
  }

  async removeStorage(): Promise<void> {
    this.alert
      .create({
        header: 'Remove Storage',
        message: `Are you sure you want to remove local storage data from this device?<br/><b>Notice: Any un-synced data will be lost!</b>`,
        backdropDismiss: false,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
          },
          {
            text: 'Confirm',
            handler: () => {
              this.storage.removeStorage().then();
            },
          },
        ],
      })
      .then((alert) => alert.present());
  }
}
